import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { EDUCATION_INFORMATION_API } from "../api";
import {
  setIsNewForEducationInformation,
  setIsDataChangedForEducation,
  addSuccessMessage,
  addErrorMessage,
  setIsLoading,
  setEducationInformationData,
} from "../slice";

export const useEducationInfo = ({ hasEditAccess }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data, isNew, isDataChanged } = useSelector((state) => state.EducationInformation);

  const { mutateAsync: addEducationInformation } = useMutation((data) =>
    EDUCATION_INFORMATION_API.AddEducationInformation(data)
  );

  const { mutateAsync: editEducationInformation } = useMutation((data) =>
    EDUCATION_INFORMATION_API.EditEducationInformation(data)
  );

  const { mutate: getEducationInformation } = useMutation(
    () => EDUCATION_INFORMATION_API.GetEducationInformation(),
    {
      onSuccess: ({ data: EducationInformation }) => {
        dispatch(setIsLoading(false));
        if (EducationInformation.success && EducationInformation.data?.length > 0) {
          dispatch(
            setEducationInformationData(EducationInformation.data ? EducationInformation.data : [])
          );
          dispatch(setIsNewForEducationInformation(false));
        }
      },
      onError: () => {
        dispatch(setIsLoading(false));
      },
      staleTime: Infinity,
    }
  );

  const filterData = (educationData) => {
    let result = JSON.parse(JSON.stringify(educationData));
    result.forEach((item, index) => {
      Object.keys(item).forEach((key) => {
        if (result[index].educationType?.toString() === "1") {
          if (educationData[index].insideEducation) {
            if (!insideUniversityEducation.includes(key)) {
              delete result[index][key];
            }
          } else {
            if (!outsideUniversityEducation.includes(key)) {
              delete result[index][key];
            }
          }
        }
        if (result[index].educationType?.toString() === "2") {
          if (educationData[index].insideEducation) {
            if (!insideSeminaryEducation.includes(key)) {
              delete result[index][key];
            }
          } else {
            if (!outsideSeminaryEducation.includes(key)) {
              delete result[index][key];
            }
          }
        } else if (result[index].educationType?.toString() === "3") {
          if (!["description", "educationType", "id", "insideEducation"].includes(key)) {
            delete result[index][key];
          }
        }
      });
    });
    return result;
  };

  const handleSubmit = async (route) => {
    if (hasEditAccess && isDataChanged) {
      if (isNew) {
        await addEducationInformation(filterData(data), {
          onSuccess: ({ data }) => {
            if (data.success) {
              dispatch(setIsNewForEducationInformation(false));
              dispatch(addSuccessMessage(data?.message));
              navigate(route);
            }
            //todo: inja byd payam ha handle beshan
          },
          onSettled: () => {
            dispatch(setIsDataChangedForEducation(false));
          },
          onError: ({ response }) => {
            dispatch(addErrorMessage(response));
          },
        });
      } else {
        await editEducationInformation(filterData(data), {
          onSuccess: ({ data }) => {
            if (data.success) {
              dispatch(addSuccessMessage(data?.message));
              navigate(route);
            }
            //todo: inja byd payam ha handle beshan
          },
          onSettled: () => {
            dispatch(setIsDataChangedForEducation(false));
          },
          onError: ({ response }) => {
            dispatch(addErrorMessage(response));
          },
        });
      }
    } else {
      navigate(route);
    }
  };
  return { handleSubmit, getEducationInformation };
};

const insideUniversityEducation = [
  "insideEducation",
  "gradeCode",
  "educationStatusCode",
  "educationGroupCode",
  "field",
  "educationProvinceId",
  "cityName",
  "educationType",
  "universityTypeCode",
  "universityName",
  "description",
  "id",
];

const outsideUniversityEducation = [
  "insideEducation",
  "gradeCode",
  "educationStatusCode",
  "educationGroupCode",
  "field",
  "educationType",
  "universityName",
  "educationCountryId",
  "description",
  "id",
];

const insideSeminaryEducation = [
  "insideEducation",
  "seminaryLevelCode",
  "educationProvinceId",
  "cityName",
  "turbansStatusCode",
  "seminarySchoolName",
  "seminaryEducationStatusCode",
  "id",
  "educationType",
  "description",
];

const outsideSeminaryEducation = [
  "insideEducation",
  "seminaryLevelCode",
  "educationCountryId",
  "cityName",
  "turbansStatusCode",
  "seminarySchoolName",
  "seminaryEducationStatusCode",
  "id",
  "educationType",
  "description",
];
